
      import { getAppLocation } from './src/_common/utils/getAppLocation.ts';
      var appLocation = getAppLocation();
      var LOADING_LABEL = {
        editor: 'Loading doDOC...',
        pdf: 'Loading doPDF...',
        presentation: 'Loading doPPT...',
      };
      var element = document.getElementsByClassName('container');
      var containerChildren = element[0].children[1];
      containerChildren.textContent = `${LOADING_LABEL[appLocation] ?? 'Loading doDOC...'}`;
    